// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Branded full-screen error for the Wix connect step. Same purple gradient as
   WixEntryLoader (.wel-screen) so a failure stays visually continuous with the
   loader instead of flashing a bare white page. */
.wixc-error {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  padding: 24px;
  text-align: center;
  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);
  font-family: 'DM Sans', system-ui, sans-serif;
  color: rgba(255, 255, 255, 0.92);
}
.wixc-error-card {
  max-width: 360px;
}
.wixc-error-card h2 {
  margin: 0 0 8px;
  font-size: 1.15rem;
  font-weight: 700;
}
.wixc-error-card p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
}
.wixc-button {
  display: block;
  width: 100%;
  margin-top: 20px;
  padding: 12px 20px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: white;
  color: #5616ea;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.wixc-button-secondary { background: transparent; color: white; border-color: rgba(255,255,255,.5); }
.wixc-button:focus-visible { outline: 2px solid white; outline-offset: 4px; }
`, "",{"version":3,"sources":["webpack://./src/pages/WixConnect.css"],"names":[],"mappings":"AAAA;;kDAEkD;AAClD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0EAA0E;EAC1E,6CAA6C;EAC7C,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA,yBAAyB,uBAAuB,EAAE,YAAY,EAAE,kCAAkC,EAAE;AACpG,6BAA6B,wBAAwB,EAAE,mBAAmB,EAAE","sourcesContent":["/* Branded full-screen error for the Wix connect step. Same purple gradient as\r\n   WixEntryLoader (.wel-screen) so a failure stays visually continuous with the\r\n   loader instead of flashing a bare white page. */\r\n.wixc-error {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 9999;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 24px;\r\n  text-align: center;\r\n  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n  color: rgba(255, 255, 255, 0.92);\r\n}\r\n.wixc-error-card {\r\n  max-width: 360px;\r\n}\r\n.wixc-error-card h2 {\r\n  margin: 0 0 8px;\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n}\r\n.wixc-error-card p {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n.wixc-button {\r\n  display: block;\r\n  width: 100%;\r\n  margin-top: 20px;\r\n  padding: 12px 20px;\r\n  border: 1px solid transparent;\r\n  border-radius: 12px;\r\n  background: white;\r\n  color: #5616ea;\r\n  font: inherit;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n.wixc-button-secondary { background: transparent; color: white; border-color: rgba(255,255,255,.5); }\r\n.wixc-button:focus-visible { outline: 2px solid white; outline-offset: 4px; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
